import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { api } from '@/lib/axios';
import { API_ROUTES, ROUTES } from '@/constants/routes';
import { WORKER_KEYS } from './useWorkerProfile';
import type { Assignment } from '@/types/worker';

export const useClaimJob = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: async (jobUuid: string): Promise<Assignment> => {
            const { data } = await api.post(API_ROUTES.workerClaimJob(jobUuid));
            return data;
        },
        onSuccess: async () => {
            toast.success('Trabajo reclamado exitosamente');
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: WORKER_KEYS.feed() }),
                queryClient.invalidateQueries({ queryKey: ['worker', 'assignments'] }),
            ]);
            navigate(ROUTES.assignments);
        },
        onError: (error: any) => {
            const detail = error?.response?.data?.detail || 'Error al reclamar el trabajo';
            toast.error(detail);
        },
    });
};
